module.exports = __webpack_public_path__ + "static/media/less_than.a0852930.svg";